import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';

import { DirectivesModule } from 'app/src/common/directives.module';
import { ContainerModule } from 'app/src/containers/container.module';
import { FileModule } from 'app/src/files/file.module';
import { MaterialModule } from 'app/src/material.module';
import { PipesModule } from 'app/src/shared/pipes.module';
import { SharedModule } from 'app/src/shared/shared.module';

import { Project } from '../../shared/models/project.model';
import { SessionDetailComponent } from './session-detail.component';

@Component({
  host: {
    class: 'mat-dialog-component',
    'test-id': 'session-detail-dialog',
  },
  selector: 'session-detail-dialog',
  template: `
    <button class="mat-dialog-close-button" mat-dialog-close mat-icon-button test-id="dialog-close-button">
      <mat-icon>close</mat-icon>
    </button>
    <mat-dialog-content [class]="{ flex: data }">
      @if (!data) {
        <session-detail class="dialog-component" />
      } @else {
        <div class="info-message">
          <div class="fab">
            <mat-icon>error_outline</mat-icon>
          </div>
          <p>
            <span>Result is attached to the project</span>
            <a href="#/projects/{{ data.parentProject._id }}/information">
              {{ data.parentProject.label || data.parentProject._id }}
            </a>
          </p>
        </div>
      }
    </mat-dialog-content>
  `,
  styleUrls: ['./session-detail-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ContainerModule,
    DirectivesModule,
    DragDropModule,
    FileModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    PipesModule,
    SharedModule,
    RouterModule,
    SessionDetailComponent,
  ],
})
export class SessionDetailDialog {
  data = inject<{
    parentProject: Project;
  }>(MAT_DIALOG_DATA);
}
